import React, { type ReactNode } from "react";
import { NavLink } from "react-router-dom";

export default function InteroperabilityNav({ children }: { children: ReactNode }) {
  return <div>
    <nav className="nav nav-tabs mb-3" aria-label="Interoperability views">
      <NavLink className="nav-link" to="/admin/interoperability/connections">EHR Connections</NavLink>
      <NavLink className="nav-link" to="/admin/interoperability/sync-activity">EHR Sync</NavLink>
    </nav>
    {children}
  </div>;
}
